var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterToolbarProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2864_9177)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.427734 1.8919V3.78382L3.19243 6.54846L5.95712 9.31309V12.6597C5.95712 14.5628 5.96424 16.0036 5.97364 16C5.98269 15.9965 7.07819 15.3407 8.40808 14.5426L10.826 13.0914V11.2022V9.31309L13.5907 6.54846L16.3554 3.78382V1.8919V0H8.39156H0.427734V1.8919ZM1.61665 2.24091V3.29293L4.38134 6.05785L7.14604 8.82279V11.3672C7.14604 12.8024 7.15319 13.9088 7.16245 13.9052C7.17149 13.9018 7.7317 13.5678 8.40738 13.163L9.63587 12.427L9.63649 10.6249L9.63709 8.82279L12.4018 6.05785L15.1665 3.29293V2.24091V1.18891H8.39156H1.61665V2.24091Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2864_9177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.427734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterToolbarProjects);
export default __webpack_public_path__ + "static/media/icon--filter-toolbar-projects.336625939130c908de3151cf19550fc5.svg";
export { ForwardRef as ReactComponent };